'use strict';

(function () {
  'use strict';

  angular.module('msUtility').directive('srefThrottle', srefThrottle);

  srefThrottle.$inject = ['$state', '$document', '$log', '$timeout'];

  /**
   * @desc A directive that throttles a user's ability to click links. Useful for pagination links,
           or any element whose href attribute might change after a user clicks on it.
           It works by removing an anchor's href attribute after it changes, then adding it back after the $timeout is complete.
   * @param {Number} msKeypressGo: Number of milliseconds the link will be disabled for.
   * @example <a ui-sref="mainState.homepage({param1: 'state param value'})" ms-sref-throttle="1000">
   */

  function srefThrottle($state, $document, $log, $timeout) {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attr) {

      if (!attr.uiSref) {
        // Technically, all this directive needs is an href, but I haven't tested this without uiSref
        // (nor do we ever change links without using uiSref to do so).
        $log.warn('This directive must be used with uiSref.');
      }

      attr.$observe('href', function (newVal) {
        if (element.attr('href')) {
          element.removeAttr('href');
          $timeout(function () {
            return element.attr('href', newVal);
          }, attr.srefThrottle);
        }
      });
    }
  }
})();